export const SET_CONTACT = 'PARTNER/CONTACT/SET_CONTACT'
export const SET_CONTACTS = 'PARTNER/CONTACT/SET_CONTACTS'
